import fetch from 'isomorphic-unfetch';
import qs from 'qs';

const request = async (path, data, useJson = true, ignoreResponse = false) => {
  const init = {
    method: 'post',
  };

  if (useJson) {
    init.headers = {
      'Content-Type': 'application/json',
    };
    init.body = JSON.stringify(data);
  } else {
    init.headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    };
    init.body = qs.stringify(data);
  }

  const response = await fetch(path, init);

  if (ignoreResponse) {
    return;
  }

  if (response.status >= 400) {
    const e = new Error('Request failed');
    e.response = await response.json();
    e.code = response.status;
    throw e;
  }

  return await response.json();
};

export async function changePassword(newPassword, currentPassword) {
  // TODO: use a Slim or Auth service endpoint instead of __call
  return request(
    '/?__call=Auth&action=change-password',
    {
      'old-password': currentPassword,
      'new-password': newPassword,
    },
    false
  );
}

export async function facebookLogin(authResponse) {
  // TODO: use a Slim or Auth service endpoint instead of __call
  return request(
    '/?__call=FacebookSSO',
    {
      authResponse,
      status: 'connected',
      requestType: 'request_log_in',
    },
    false
  );
}

export async function googleLogin(tokenId) {
  // TODO: use a Slim or Auth service endpoint instead of __json
  return request(
    '/?__json=Modal_Registration',
    {
      code: tokenId,
      action: 'login-google',
    },
    false
  );
}

export async function localLogin(
  email,
  password,
  gdprOptIn,
  captchaValue,
  recaptchaToken
) {
  return request('/api/login', {
    username: email,
    password,
    gdprOptIn,
    remember: 1,
    // TODO: don't pass this in
    __redirect: window.location.href,
    // TODO: is this needed?
    jsFinished: 1,
    recaptcha: captchaValue,
    recaptchaEnterpriseToken: recaptchaToken,
  });
}

/**
 * Checks whether an email address exists in the system.
 * @param email
 * @returns {Promise<undefined|*>}
 */
export async function checkEmail(email) {
  return request('/api/check-email', { email });
}

/**
 * Verifies emails by BriteVerify (https://docs.briteverify.com/#e5dd413c-6411-4078-8b4c-0e787f6a9325)
 * @param email
 * @returns {Promise<undefined|*>}
 */
export async function verifyEmailByBriteVerify(email) {
  return request(
    '/?__json=Modal_Registration',
    {
      action: 'verifyEmailByBriteVerify',
      email: email,
    },
    false
  );
}

export async function screenEmail(email) {
  return request(
    '/?__json=Modal_Registration',
    {
      action: 'checkemail',
      email: email,
    },
    false
  );
}

export async function validateResetKey(key) {
  // TODO: use a Slim or Auth service endpoint instead of __call
  return request(
    '/?__call=PasswordReset',
    {
      action: 'checkKey',
      key,
    },
    false
  );
}

export async function emailReset(email) {
  // TODO: use a Slim or Auth service endpoint instead of __call
  return request(
    '/?__call=PasswordReset',
    {
      action: 'emailreset',
      email,
    },
    false
  );
}

export async function resetPassword(key, password) {
  // TODO: use a Slim or Auth service endpoint instead of __call
  return request(
    '/?__call=PasswordReset',
    {
      action: 'changepass',
      key,
      password,
    },
    false
  );
}

export async function register(
  email,
  password,
  emailPreferences,
  gdprOptIn,
  type,
  isEmailRisky,
  captchaValue,
  recaptchaToken
) {
  return request('/api/member/register', {
    emailaddress: email,
    password,
    emailPreferences,
    gdprOptIn,
    grades: [],
    type: [type],
    shortreg: 0,
    jsFinished: 1,
    isEmailRisky,
    recaptcha: captchaValue,
    recaptchaEnterpriseToken: recaptchaToken,
  });
}
